<template>
  <div
    id="cookie-banner"
    class="fixed bottom-0 w-full bg-primary-color flex justify-between sm:py-5 sm:px-10 p-4 items-center text-white space-x-2 bg-opacity-90"
    style="z-index: 100"
    v-if="show"
  >
    <div>
      Youverse uses cookies to ensure you get the best experience. By clicking
      "Allow", you agree to our
      <inertia-link
        :href="$route('cookiespolicy')"
        class="link"
        style="color: white; text-decoration: underline"
        >Cookies Policy</inertia-link
      >.
    </div>
    <div
      class="inline-flex cursor-pointer items-center px-6 py-3 font-bold leading-4 bg-white rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 hover:bg-gray-100 focus:ring-gray-400 text-gray-800"
      @click="setCookie()"
    >
      Allow
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      cookieName: "allow_cookies",
    };
  },
  mounted() {
    this.show = this.getCookie(this.cookieName) == "";
  },
  methods: {
    setCookie() {
      const d = new Date();
      d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = this.cookieName + "=" + ";" + expires + ";path=/";
      this.show = false;
      this.moveNewsletter();
      this.moveHubSpotIfCookieMissing();
      window.dispatchEvent(new Event('cookies:accepted'))
    },
    getCookie() {
      let name = this.cookieName;
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    moveNewsletter() {
      let newsletterButton = document.getElementById("newsletter-button");
      let newsletterGreeting = document.getElementById("newsletter-greeting");
      if (newsletterButton) {
        newsletterButton.style.bottom = "20px";
      }
      if (newsletterGreeting) {
        newsletterGreeting.style.bottom = "95px";
      }
    },

    moveHubSpotIfCookieMissing() {
      if (!this.show) {
        document.getElementById("hubspot-messages-id").remove();
      }
    },
  },
};
</script>